import { fetchData } from "./client";

function configFromResponse(result) {
  if (result?.publicKey) return result;
  if (result?.data?.publicKey || result?.data?.channelId) return result.data;
  return result?.data && typeof result.data === "object" && !Array.isArray(result.data)
    ? result.data
    : result;
}

export async function getSiteWebchatConfig(channelId) {
  const result = await fetchData(`/channels/${channelId}/site-webchat`, "GET");
  return configFromResponse(result);
}

export async function updateSiteWebchatConfig(channelId, body) {
  const result = await fetchData(`/channels/${channelId}/site-webchat`, "PUT", body);
  return configFromResponse(result);
}
